export const stringSkip = ({ str, length }) => {
  if (str.length > length) {
    // length 전의 공백을 찾아서 거기까지 쓰고 ... 붙이기
    let i = length - 1;
    while (str[i] !== " ") i--;
    return str.slice(0, i + 1) + "...";
  } else {
    return str;
  }
};
